import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { CssBaseline } from '@mui/material';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';

import { auth } from '../firebase.config';
import NavigationScroll from 'layout/NavigationScroll';
import Routes from 'routes';
import theme from 'themes';

const App = () => {
  const customization = useSelector((state) => state.customization);
  const navigate = useNavigate();
  const location = useLocation();

  // useEffect(() => {
  //   const unsubscribe = onAuthStateChanged(auth, (user) => {
  //     if (user && location.pathname === '/') {
  //       // navigate('/main/stores');
  //        navigate('/main/stores/storeinsight');
  //     }
  //   });

  //   return () => unsubscribe();
  // }, [navigate, location.pathname]);

// App.jsx (inside useEffect redirect)
useEffect(() => {
  const unsubscribe = onAuthStateChanged(auth, (user) => {
    const hasToken = !!localStorage.getItem('accessToken');
    if ((user || hasToken) && location.pathname === '/') {
      navigate('/'); // optional: if you want to always go home first
      navigate('/main/stores/storeinsight', { replace: true });
    }
  });
  return () => unsubscribe();
}, [navigate, location.pathname]);





  return (
    <NavigationScroll>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme(customization)}>
          <CssBaseline />
          <Routes />
        </ThemeProvider>
      </StyledEngineProvider>
    </NavigationScroll>
  );
};

export default App;
